import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Icon } from '@concretecode/ui-pure';
import { PureToastService, ToastItem, ToastType } from '@concretecode/data';

@Component({
  selector: 'app-toast',
  imports: [Icon],
  templateUrl: './toast.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast {
  readonly #toastService = inject(PureToastService);

  protected readonly toasts = this.#toastService.toasts;

  protected dismiss(id: number): void {
    this.#toastService.dismiss(id);
  }

  protected iconFor(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'check-circle';
      case 'info':
        return 'information-circle';
      case 'error':
        return 'exclamation-triangle';
    }
  }

  protected trackById(_index: number, item: ToastItem): number {
    return item.id;
  }
}
